import { Box, Spinner, Tabs, Text } from '@chakra-ui/react'
import { useParams } from 'react-router'
import { useAgendaDetails } from '@/hooks/agendas/useAgendaDetails'
import { LuCalendarCheck, LuLock, LuTag, LuUsers, LuWallet } from 'react-icons/lu'
import AgendaDetailsHeader from './components/AgendaDetailsHeader'
import PlanTab from './components/PlanTab'
import MembersTab from './components/MembersTab'
import EventsTab from './components/EventsTab'
import ExpenseCategoriesTab from './components/ExpenseCategoriesTab'
import { hasPermission, AGENDA_PERMISSIONS } from '@/utils/agendaPermissions'

const AgendasDetails = () => {
  const { agendaId } = useParams<{ agendaId: string }>()
  const { data: agenda, isLoading } = useAgendaDetails(agendaId!)


  if (isLoading) return <Spinner size="lg" color="primary.500" />

  if (!agenda) return <Text color="fg.muted">Agenda não encontrada.</Text>

  const canViewEvents =
    agenda.role !== 'member' || hasPermission(agenda.permissions, AGENDA_PERMISSIONS.VIEW_EVENTS)

  const canViewFinancial =
    agenda.role !== 'member' || hasPermission(agenda.permissions, AGENDA_PERMISSIONS.VIEW_FINANCIAL)

  return (
    <Box display="flex" flexDirection="column" flex="1" minH="0">
      <AgendaDetailsHeader agenda={agenda} />

      <Tabs.Root defaultValue="events" size="sm" variant="line" display="flex" flexDirection="column" flex="1" minH="0" overflow="hidden">
        <Tabs.List px="4">
          <Tabs.Trigger value="events" disabled={!canViewEvents}>
            {canViewEvents ? <LuCalendarCheck /> : <LuLock />}
            Eventos
          </Tabs.Trigger>
          <Tabs.Trigger value="members">
            <LuUsers />
            Membros
          </Tabs.Trigger>
          <Tabs.Trigger value="expense-categories" disabled={!canViewFinancial}>
            {canViewFinancial ? <LuWallet /> : <LuLock />}
            Centro de custos
          </Tabs.Trigger>
          <Tabs.Trigger value="plan">
            <LuTag />
            Plano
          </Tabs.Trigger>
        </Tabs.List>
        <Tabs.Content value="events" flex="1" overflowY="auto" minH="0" p="0">
          <EventsTab />
        </Tabs.Content>
        <Tabs.Content value="members">
          <MembersTab agenda={agenda} />
        </Tabs.Content>
        <Tabs.Content value="expense-categories">
          <ExpenseCategoriesTab />
        </Tabs.Content>
        <Tabs.Content value="plan">
          <PlanTab />
        </Tabs.Content>
      </Tabs.Root>
    </Box>
  )
}

export default AgendasDetails
